module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/cookies");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/config");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/request");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/utils/static");

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var smarket_pithy_src_tools_request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var smarket_pithy_src_tools_request__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(smarket_pithy_src_tools_request__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
/* harmony import */ var smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3__);




var apiArticle = {
  extend: function extend(apiName, path) {
    apiArticle[apiName] = function (params) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Object(smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0__["onSync"])(path, params, config);
    };
  },

  /**
  * 获取某个栏目下的栏目列表,包含子级栏目
  * @param articleCategoryId 栏目id
  * @param moduleId
  * @param instanceId
  * @param isEnabled 是否前台可见(1是 0否)
  * @returns {Promise<any>}
  */
  onArticleCategorySubQuery: function onArticleCategorySubQuery(_ref) {
    var articleCategoryId = _ref.articleCategoryId,
        _ref$moduleId = _ref.moduleId,
        moduleId = _ref$moduleId === void 0 ? 0 : _ref$moduleId,
        _ref$instanceId = _ref.instanceId,
        instanceId = _ref$instanceId === void 0 ? '' : _ref$instanceId,
        _ref$isEnabled = _ref.isEnabled,
        isEnabled = _ref$isEnabled === void 0 ? 1 : _ref$isEnabled;
    return Object(smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0__["onSync"])("/api/article/category/sub/query", {
      tenantId: smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()("tenantId"),
      articleCategoryId: articleCategoryId,
      moduleId: moduleId,
      instanceId: instanceId,
      isEnabled: isEnabled
    });
  },

  /**
  * 获取某个栏目下的栏目列表（带分页）
  * @param articleCategoryId 栏目id
  * @param tenantId
  * @param instanceId
  * @param isEnabled 是否前台可见(1是 0否)
  * @param isWithTemplate 是否返回模板信息（1：是；0：否）|必填
  * @param start 索引 , 从0开始，传1代表数据从第二条开始查询|必填
  * @param num 当次返回的条数, 1~50
  * @returns {Promise<any>}
  */
  onArticleCategoryQuery: function onArticleCategoryQuery(_ref2) {
    var articleCategoryId = _ref2.articleCategoryId,
        _ref2$tenantId = _ref2.tenantId,
        tenantId = _ref2$tenantId === void 0 ? smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()("tenantId") : _ref2$tenantId,
        _ref2$instanceId = _ref2.instanceId,
        instanceId = _ref2$instanceId === void 0 ? '' : _ref2$instanceId,
        _ref2$isEnabled = _ref2.isEnabled,
        isEnabled = _ref2$isEnabled === void 0 ? 1 : _ref2$isEnabled,
        _ref2$isWithTemplate = _ref2.isWithTemplate,
        isWithTemplate = _ref2$isWithTemplate === void 0 ? 1 : _ref2$isWithTemplate,
        _ref2$start = _ref2.start,
        start = _ref2$start === void 0 ? 0 : _ref2$start,
        _ref2$num = _ref2.num,
        num = _ref2$num === void 0 ? 50 : _ref2$num;
    return Object(smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0__["onSync"])("/api/article/category/sub/query", {
      tenantId: tenantId,
      articleCategoryId: articleCategoryId,
      isWithTemplate: isWithTemplate,
      instanceId: instanceId,
      isEnabled: isEnabled,
      start: start,
      num: num
    });
  },

  /**
   * 获取文章列表
   * @param instanceId 实例id
   * @param articleIds 文章ids
   * @param typeIds 分类ids
   * @param articleCategoryId 文章所属栏目ids
   * @param title 文章标题
   * @param summary 文章摘要
   * @param isRecommend 是否推荐(-1全部 0不推荐 1推荐)
   * @param hasChildrenCategory 文章分类是否包含子栏目(1是 0否)
   * @param isTop 是否置顶(-1全部 0不置顶 1置顶)
   * @param isWithStat 是否需要点赞、分享、浏览统计(1是 0否)
   * @param sort 排序方式，默认按创建时间倒序排序(1创建时间正序 2创建时间倒序 3最后更新时间正序 4最后更新时间倒序 5排序字段正序 6排序字段倒序)
   * @param tags 标签ids(支持标签属性之间的并且、或；并且格式：[{tagId0:["吃饭"]},{tagId1:["打豆豆"]}]；或格式：[{tagId0:["打豆豆"],tagId1:["打豆豆"]}])
   * @param start
   * @param num
   * @returns {*}
   */
  onArticleQuery: function onArticleQuery(_ref3) {
    var _ref3$instanceId = _ref3.instanceId,
        instanceId = _ref3$instanceId === void 0 ? 0 : _ref3$instanceId,
        articleIds = _ref3.articleIds,
        typeIds = _ref3.typeIds,
        articleCategoryId = _ref3.articleCategoryId,
        title = _ref3.title,
        summary = _ref3.summary,
        _ref3$isRecommend = _ref3.isRecommend,
        isRecommend = _ref3$isRecommend === void 0 ? -1 : _ref3$isRecommend,
        _ref3$hasChildrenCate = _ref3.hasChildrenCategory,
        hasChildrenCategory = _ref3$hasChildrenCate === void 0 ? 1 : _ref3$hasChildrenCate,
        _ref3$isTop = _ref3.isTop,
        isTop = _ref3$isTop === void 0 ? -1 : _ref3$isTop,
        _ref3$isWithStat = _ref3.isWithStat,
        isWithStat = _ref3$isWithStat === void 0 ? 1 : _ref3$isWithStat,
        _ref3$sort = _ref3.sort,
        sort = _ref3$sort === void 0 ? [6, 4] : _ref3$sort,
        tags = _ref3.tags,
        _ref3$start = _ref3.start,
        start = _ref3$start === void 0 ? 0 : _ref3$start,
        _ref3$num = _ref3.num,
        num = _ref3$num === void 0 ? 50 : _ref3$num;
    return Object(smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0__["onSync"])("/api/article/query", {
      tenantId: smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()("tenantId"),
      instanceId: instanceId,
      articleIds: articleIds,
      typeIds: typeIds,
      articleCategoryId: articleCategoryId,
      title: title,
      summary: summary,
      isRecommend: isRecommend,
      hasChildrenCategory: hasChildrenCategory,
      isTop: isTop,
      isWithStat: isWithStat,
      sort: sort,
      tags: tags,
      start: start,
      num: num
    });
  },

  /**
   * 获取文章详情信息
   * @param articleId 文章id
   * @param isWithStat 是否需要点赞、分享、浏览统计(1是 0否)
   * @param isScroll 是否需要查询上一篇和下一篇文章id(1是 0否)
   * @param isWithTag 是否需要标签(1是 0否)
   * @returns {Promise<any>}
   */
  onArticleGet: function onArticleGet(_ref4) {
    var articleId = _ref4.articleId,
        _ref4$isWithStat = _ref4.isWithStat,
        isWithStat = _ref4$isWithStat === void 0 ? 1 : _ref4$isWithStat,
        _ref4$isScroll = _ref4.isScroll,
        isScroll = _ref4$isScroll === void 0 ? 0 : _ref4$isScroll,
        _ref4$isWithTag = _ref4.isWithTag,
        isWithTag = _ref4$isWithTag === void 0 ? 1 : _ref4$isWithTag;
    return Object(smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0__["onSync"])("/api/article/get", {
      tenantId: smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()("tenantId"),
      articleId: articleId,
      globalUserId: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.globalUserId(),
      sess: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')) && smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')).session,
      openId: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.openId(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('weChatId')),
      isWithStat: isWithStat,
      isScroll: isScroll,
      isWithTag: isWithTag
    });
  },

  /**
   * 获取文章栏目信息
   * @param articleCategoryId 文章栏目id
   * @param tenantId
   * @returns {Promise<any>}
   */
  onArticleCategoryGet: function onArticleCategoryGet(_ref5) {
    var articleCategoryId = _ref5.articleCategoryId,
        _ref5$tenantId = _ref5.tenantId,
        tenantId = _ref5$tenantId === void 0 ? smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('tenantId') : _ref5$tenantId;
    return Object(smarket_pithy_src_utils_static__WEBPACK_IMPORTED_MODULE_0__["onSync"])("/api/article/category/get", {
      tenantId: tenantId,
      articleCategoryId: articleCategoryId
    });
  },

  /**
   * 获取当前用户的收藏列表
   * @param start
   * @param num
   * @returns {*}
   */
  onArticleGetCollectionList: function onArticleGetCollectionList(_ref6) {
    var start = _ref6.start,
        num = _ref6.num;
    return smarket_pithy_src_tools_request__WEBPACK_IMPORTED_MODULE_1___default.a.postJson("/article/getCollectionList", {
      start: start,
      num: num,
      sess: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')) && smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')).session
    }).catch(function (data) {
      // 暂无收藏数据
      if (data.result == "268451864") {
        return {
          content: [],
          desc: "successful",
          result: 0
        };
      }
    });
  },

  /**
  * 文章浏览
  * @param articleId     文章id
  * @param sess          用户session
  * @param globalUserId
  * @param openId        微信openId
  * @param url           页面url
  * @param referenceUrl 页面的referenceUrl
  * @param equipment     浏览器信息
  * @returns {*}
  */
  onArticleBrowse: function onArticleBrowse(_ref7) {
    var articleId = _ref7.articleId,
        pageTitle = _ref7.pageTitle,
        browseInfo = _ref7.browseInfo;
    return smarket_pithy_src_tools_request__WEBPACK_IMPORTED_MODULE_1___default.a.postJson("/article/browse", {
      articleId: articleId,
      pageTitle: pageTitle,
      browseInfo: browseInfo,
      url: window.location.href,
      referenceUrl: document.referrer,
      sess: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')) && smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')).session,
      globalUserId: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.globalUserId()
    });
  },

  /**
   * @description: 点赞
   * @param n*o articleId
   * @return n*o
   */
  onArticleLike: function onArticleLike(_ref8) {
    var articleId = _ref8.articleId;
    return smarket_pithy_src_tools_request__WEBPACK_IMPORTED_MODULE_1___default.a.postJson("/article/like", {
      articleId: articleId,
      url: window.location.href,
      sess: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')) && smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')).session,
      globalUserId: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.globalUserId()
    });
  },

  /**
   * @description: 收藏
   * @param n*o articleId
   * @param n*o status
   * @return n*o
   */
  onArticleCollect: function onArticleCollect(_ref9) {
    var articleId = _ref9.articleId,
        status = _ref9.status;
    return smarket_pithy_src_tools_request__WEBPACK_IMPORTED_MODULE_1___default.a.postJson("/article/Collection", {
      articleId: articleId,
      status: status,
      url: window.location.href,
      sess: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')) && smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')).session,
      globalUserId: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.globalUserId()
    });
  },

  /**
   * @description: 获取点赞状态
   * @param n*o articleId
   * @return n*o
   */
  getLikeStatus: function getLikeStatus(_ref10) {
    var articleId = _ref10.articleId;
    return smarket_pithy_src_tools_request__WEBPACK_IMPORTED_MODULE_1___default.a.postJson("/api/article/like/check", {
      articleId: articleId,
      url: window.location.href,
      tenantId: smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()("tenantId"),
      sess: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')) && smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')).session,
      globalUserId: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.globalUserId()
    });
  },

  /**
   * @description: 获取收藏状态
   * @param n*o articleId
   * @return n*o
   */
  getCollectStatus: function getCollectStatus(_ref11) {
    var articleId = _ref11.articleId;
    return smarket_pithy_src_tools_request__WEBPACK_IMPORTED_MODULE_1___default.a.postJson("/api/article/collection/check", {
      articleId: articleId,
      tenantId: smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()("tenantId"),
      sess: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')) && smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.smarketMember(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_2___default()('schemaId')).session,
      globalUserId: smarket_pithy_src_tools_cookies__WEBPACK_IMPORTED_MODULE_3___default.a.globalUserId()
    });
  }
  /**
   * @description: 获取评论列表
   * @param n*o topicId
   * @param n*o subVersionId
   * @return n*o
   */

};
/* harmony default export */ __webpack_exports__["default"] = (apiArticle);

/***/ })
/******/ ]);